import { Button } from "@src/appV2/redesign/components/Button";

interface TimekeepingActionButtonProps {
  title: string;
  onClick: () => void;
}

export function TimekeepingActionButton(props: TimekeepingActionButtonProps) {
  const { title, onClick } = props;

  return (
    <Button
      startIconType="clock"
      sx={(theme) => ({ boxShadow: theme.shadows[3] })}
      onClick={onClick}
    >
      {title}
    </Button>
  );
}
